export const isLoading = state => state.archive?.fetching && !state.archive?.fetched
